<template>
    <div class="px-4 py-8 sm:px-10">
        <h2 class="text-lg leading-6 font-medium text-gray-900">{{ translate('home.body:headline') }}</h2>
        <form @submit.prevent="submit" class="space-y-6">
            <div>
                <p class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 mb-4">{{ translate('home.body:subline') }}</p>
                <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <label for="nft-logo" class="cursor-pointer bg-white font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none">
                        <div class="flex justify-center px-6 pt-6 pb-6 border-2 border-gray-300 border-dashed border-blue-500 hover:bg-blue-100" v-if="!form.progress">
                            <div class="space-y-1 text-center">
                                <svg class="mx-auto h-12 w-12 text-blue-500" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <div class="flex text-sm text-gray-600 text-center">
                                    <span class="text-blue-600">{{ translate('home.body:upload') }}</span>
                                    <input id="nft-logo" name="nft-logo" type="file" class="sr-only" @input="form.nftLogo = $event.target.files[0]; submit()" />
                                </div>
                                <p class="text-xs text-gray-500">{{ translate('home.body:fileTypes') }}</p>
                                <p v-if="form.errors.nftLogo" class="text-red-500 mt-3">{{ form.errors.nftLogo }}</p>
                            </div>
                        </div>
                        <div class="flex justify-center px-6 pt-6 pb-6 border-2 border-gray-300 border-dashed border-blue-500 hover:bg-blue-100" v-if="form.progress">
                            <div class="space-y-1 text-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                                <div class="flex text-sm text-gray-600 text-center">
                                    <span class="text-blue-600">{{ translate('home.body:isUploading') }}</span>
                                </div>
                                <progress class="progress-bar" :value="form.progress.percentage" max="100">
                                    <div class="progress-bar">
                                        <span :style="`width: ${form.progress.percentage}%;`">{{ translate('home.body:uploadProgress') }}: {{ form.progress.percentage }}%%</span>
                                    </div>

                                </progress>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
        </form>
    </div>

</template>

<script>

import {useForm, usePage} from "@inertiajs/inertia-vue3";
import translate from "../../lang";

export default {
    data() {
        return {
            loadingPerc: 0
        }
    },
    components: {
    },
    props: {
        metaDataType: Object
    },

    setup(props) {
        const form = useForm({
            nftLogo: null,
        });

        function submit() {
            form.post(window.route('loc_upload', {metaDataType: props.metaDataType }));
        }

        return {
            form,
            submit,
            translate: translate('upload-' + usePage().props.value.metaDataType.type)
        }
    }
};
</script>

<style>
.progress-bar {
    background-color: whiteSmoke;
    border-radius: 2px;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25) inset;

    width: 250px;
    height: 20px;

    position: relative;
    display: block;
}

.progress-bar > span {
    background-color: blue;
    border-radius: 2px;

    display: block;
    text-indent: -9999px;
}

</style>
